import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ICounseling {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  sub_title?: string;
  sub_title_text_color?: string;
  cta_text?: string;
  cta_text_color?: string;
  cta_button_background_color?: string;
  cta_button_icon?: string;
  cta_button_icon_alt?: string;
  background_color?: string;
  variant?: string;
  status?: boolean;
}

/**
 * Create counseling entry
 */
export async function createCounseling(payload: Partial<ICounseling>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.COUNSELING.CREATE, payload);
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update counseling
 */
export async function updateCounseling(id: number, payload: Partial<ICounseling>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.COUNSELING.UPDATE(id), payload);
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get counseling by page ID
 */
export async function getCounselingByPageId(pageId: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.COUNSELING.GET_BY_PAGE_ID(pageId));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      return null;
    }
    const errorResponse = handleApiError(axiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Delete counseling
 */
export async function deleteCounseling(id: number) {
  try {
    const response = await adminAxios.delete(ADMIN_API_ENDPOINTS.COUNSELING.DELETE(id));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
